const InitGsapSkill = ({
    gsap,
    getSkillsGroupRef,
    getSkillsRef,
}) => {
    getSkillsRef?.forEach((skill_group, index) => {
        if (skill_group?.length > 0) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: getSkillsGroupRef[index],
                    start: "top 100%",
                    end: "top 82%",
                    scrub: true,
                    toggleActions: "play none none none",
                    // markers: true,
                    onEnter: () => { },
                    onLeaveBack: () => { }
                },
            })
                .from(skill_group[0], {
                    x: -300,
                    duration: 1, ease: 'none',
                })

            gsap.timeline({
                scrollTrigger: {
                    trigger: getSkillsGroupRef[index],
                    start: "top 100%",
                    end: "top 82%",
                    scrub: true,
                    toggleActions: "play none none none",
                    // markers: true,
                    onEnter: () => { },
                    onLeaveBack: () => { }
                },
            })
                .from(skill_group[1], {
                    x: 0,
                    y: 300,
                    duration: 1, ease: 'none',
                })

            gsap.timeline({
                scrollTrigger: {
                    trigger: getSkillsGroupRef[index],
                    start: "top 100%",
                    end: "top 82%",
                    scrub: true,
                    toggleActions: "play none none none",
                    // markers: true,
                    onEnter: () => { },
                    onLeaveBack: () => { }
                },
            })
                .from(skill_group[2], {
                    x: 300,
                    duration: 1, ease: 'none',
                })
        }
    })

    return () => {
        getSkillsRef?.forEach((skill_group, index) => {
            if (skill_group?.length > 0) {
                gsap.killTweensOf(getSkillsGroupRef[index]);
                gsap.killTweensOf(skill_group[0]);
                gsap.killTweensOf(skill_group[1]);
                gsap.killTweensOf(skill_group[2]);
            }
        })
    }
}

export default InitGsapSkill